// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-dropdown {
  position: relative;
  width: 100%;
}
@media screen and (max-width: 992px) {
  .ui-dropdown {
    width: auto;
    min-width: 40px;
    flex-shrink: 0;
  }
}
@media screen and (max-width: 576px) {
  .ui-dropdown {
    min-width: 36px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Dropdown/Dropdown.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;AACF;AAEE;EALF;IAMI,WAAA;IACA,eAAA;IACA,cAAA;EACF;AACF;AACE;EAXF;IAYI,eAAA;EAEF;AACF","sourcesContent":[".ui-dropdown {\n  position: relative;\n  width: 100%;\n\n  // Mobile responsive styles\n  @media screen and (max-width: 992px) {\n    width: auto;\n    min-width: 40px;\n    flex-shrink: 0;\n  }\n\n  @media screen and (max-width: 576px) {\n    min-width: 36px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
